<template id="button-list-manif">
    <router-link :to="{ name: nome, params: { opcao: op  } }" class="wfs--button">
        {{titulo}}
    </router-link>
</template>

<script>
export default {
  name: "reload-v1",
  props: {
    nome:{
      type: String,
      default: "realizarManifestacao",
    },
    op:{
      type: Number,
      default: 1, 
    },
    titulo:{
      type: String,
      default: "Reclamação",
    },
  },
  methods: {

  },
};
</script>

